import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { getProductUrl } from "../libs/getProductUrl";
import { isProductInStock } from "../libs/productStock";
import ProductPriceDisplay, { ProductDiscountBadge } from "./ProductPriceDisplay";
import StarRating from "./StarRating";
import "./ProductCard.css";
const PLACEHOLDER = "/placeholder-product.png";

export const clampDescription = (description, maxLength = 60) => {
  if (!description) return "";
  if (description.length <= maxLength) return description;
  return `${description.slice(0, maxLength)}...`;
};

const ProductCard = ({ product, cardRef, onAddToCart }) => {
  const inStock = isProductInStock(product);
  const quantity = Number(product.quantity) || 0;
  const salesCount = Number(product.salesCount) || 0;
  const lowStock = inStock && quantity > 0 && quantity <= 5;

  return (
    <article className="product-card-modern category-product-info" ref={cardRef}>
      <Link to={getProductUrl(product)} className="product-card-modern__media">
        {product.images?.[0] ? (
          <img
            src={product.images[0]}
            alt={product.name}
            onError={(e) => {
              e.target.src = PLACEHOLDER;
            }}
          />
        ) : (
          <Skeleton height="100%" />
        )}
        <ProductDiscountBadge product={product} />
        {!inStock && <span className="product-card-modern__badge">Sold out</span>}
        {lowStock && <span className="product-card-modern__badge product-card-modern__badge--low">Only {quantity} left</span>}
      </Link>
      <div className="product-card-modern__body">
        <Link to={getProductUrl(product)} className="product-card-modern__title">
          {product.name}
        </Link>
        {(product.avgRating > 0 || product.reviewCount > 0) && (
          <StarRating rating={product.avgRating} count={product.reviewCount} size="sm" />
        )}
        <ProductPriceDisplay product={product} size="card" />
        <div className="product-card-modern__meta">
          {salesCount > 0 && <span>{salesCount} sold</span>}
          {inStock && quantity > 5 && <span>{quantity} in stock</span>}
        </div>
        {product.description && (
          <p className="product-card-modern__desc">{clampDescription(product.description)}</p>
        )}
        <div className="product-card-modern__actions btnn">
          {inStock ? (
            <button
              type="button"
              className="product-card-modern__btn"
              onClick={() => onAddToCart(product)}
            >
              Add to cart
            </button>
          ) : (
            <button type="button" className="product-card-modern__btn product-card-modern__btn--disabled" disabled>
              Sold out
            </button>
          )}
        </div>
      </div>
    </article>
  );
};

export default ProductCard;
